import { useContext, useEffect } from "react";
import { CenteredSwiperContext } from "./CenteredSwiperContext";

export function useCenteredSwiperSlide({
	index,
	isActive,
}: UseCenteredSwiperSlideArgs) {
	const { setSelectedSlideIndex } = useContext(CenteredSwiperContext);

	useEffect(() => {
		if (isActive) {
			setSelectedSlideIndex(index);
		}
	}, [isActive, index]);
}

export type UseCenteredSwiperSlideArgs = {
	isActive: boolean;
	index: number;
};
